"use client"

import Link from "next/link"
import { ArrowRight, Sparkles } from "lucide-react"
import { motion } from "motion/react"

import { useSmoothScroll } from "@/hooks/use-smooth-scroll"
import { buttonVariants } from "@/components/ui/button"

export function CtaSection() {
  const handleSmoothScroll = useSmoothScroll()

  return (
    <section className="py-16">
      <div className="bg-primary rounded-3xl border border-white/20 px-8 py-12 text-white shadow-lg sm:px-12 dark:border-white/10">
        <div className="flex flex-col gap-8 lg:flex-row lg:items-center lg:justify-between">
          <div className="space-y-4">
            <div className="inline-flex items-center gap-2 rounded-full border border-white/40 bg-white/20 px-4 py-1 text-xs font-semibold tracking-[0.3em] text-white uppercase">
              <Sparkles className="h-3.5 w-3.5" />
              Instant insights
            </div>
            <div className="space-y-3">
              <h2 className="text-3xl leading-tight font-semibold sm:text-4xl">
                Ready to optimize your tokens?
              </h2>
              <p className="text-lg">
                Compare formats, highlight tokens, and trim usage before you hit
                deploy.
              </p>
            </div>
          </div>
          <div className="flex flex-col gap-3 sm:flex-row">
            <Link
              href="/analyze"
              className={buttonVariants({
                variant: "secondary",
                size: "lg",
              })}
            >
              Get Started Free
              <ArrowRight className="h-4 w-4" />
            </Link>
            <motion.button
              type="button"
              whileHover={{ y: -2, opacity: 0.95 }}
              whileTap={{ scale: 0.98 }}
              onClick={() => handleSmoothScroll("features")}
              aria-label="View features"
              className={buttonVariants({
                variant: "ghost",
                size: "lg",
                className:
                  "w-full border border-white/40 text-white hover:bg-white/20 hover:text-white sm:w-auto",
              })}
            >
              View features
            </motion.button>
          </div>
        </div>
      </div>
    </section>
  )
}
